module.exports = __webpack_public_path__ + "img/icon (12).fa3d8796.png";